import { Component, OnInit } from '@angular/core';
import { Logs, Activities, Updates, Users } from 'api/collections';
import { Log, Update } from 'api/models';
import { NavParams } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { ISDEV } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { SharedService } from '../../services/sharedService';

import { ActivityService, AugmentedActivity } from '../../services/activityData';
@Component({
  selector: 'log-activity-details',
  templateUrl: 'log-activity-details.html'
})

export class LogActivityDetailsPage implements OnInit {
public isDev = ISDEV;
  activity: AugmentedActivity;
  update: Update;
  log: Log;
  logId: string;
  creatorName: string;

  constructor(
    public navParams: NavParams,
    public httpService: HttpService,
    private activityService: ActivityService,
    private sharedService: SharedService,
  ) {
    this.logId = <string>navParams.get('logId');
  }

  ngOnInit() {

  if(this.isDev == true) {   console.log('log activity details page') }

    /*
    MeteorObservable.subscribe('logDetails', this.logId).subscribe(() => {
      MeteorObservable.autorun().subscribe(() => {
        if (this.logId){
            this.log = Logs.collection.findOne(this.logId);
            if (this.log && this.log.p6ActivityId) {
              const activities = Activities.collection.find({
                p6ActivityId: this.log.p6ActivityId,
                projectId: this.log.projectId,
              }, {
                limit: 1,
                sort: { createdAt: -1 },
              }).fetch();
              this.activity = getAugmentedActivity(activities[0]);
              this.update = Updates.collection.findOne(this.activity.updateId);
            }

            this.creatorName = '';
            if (this.log && this.log.creatorId) {
              const creatorUser = Meteor.users.findOne(this.log.creatorId);
              if (creatorUser && creatorUser.profile) {
                this.creatorName = creatorUser.profile.name;
              }
            }
          }
      });
    });
    */

    this.httpService.MeteorSubscribe('logDetails',this.logId)
    .then(()=>this.httpService.privateLoopAction(true))
      .then(() => {
      MeteorObservable.autorun().subscribe(() => {
        if (this.logId){
            this.log = Logs.findOne(this.logId);
            if (this.log && this.log.p6ActivityId) {
              const activities = Activities.find({
                p6ActivityId: this.log.p6ActivityId,
                projectId: this.log.projectId,
              }, {
                limit: 1,
                sort: { createdAt: -1 },
              }).fetch();
              this.activity = this.activityService.getAugmentedActivity(activities[0]);
              this.update = Updates.findOne(this.activity.updateId);
            }

            this.creatorName = '';
            if (this.log && this.log.creatorId) {
              const creatorUser = Users.findOne(this.log.creatorId);
              if (creatorUser && creatorUser.profile) {
                this.creatorName = creatorUser.profile.name;
              }
            }
          }
      });
    
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/log-activity-details/log-activity-details.ts